import React from 'react'

import * as numberOfDocTypes from './numberOfDocTypes'
import { useForm } from 'react-final-form'
import useLookupClient from '../../../../services/lookupClient/useLookupClient'

const useNumberOfDoc = (props: numberOfDocTypes.UseNumberOfDocType) => {
    const { callbackFunc } = props
    const lookupClient = useLookupClient()
    const form = useForm()

    const changeToNull = (name: string) => {
        form.change(`${name}`, null)
    }

    const handleChangeRequireDoc = (value: numberOfDocTypes.OptType) => {
        if (callbackFunc && value) {
            callbackFunc(value.value)
        }

        if (value && value.value === '0') {
            changeToNull('documentNumber')
            changeToNull('sendDocumentDate')
            changeToNull('remark')
        } else {
            form.change(`sendDocumentDate`, new Date())
        }
        form.restart()
    }
    return {
        condition: lookupClient.getNeedDoc(),
        onChangRequireDoc: handleChangeRequireDoc,
    }
}

export default useNumberOfDoc
